import type { BotSkillLevel } from '@ppwr/poker-engine/utils'

export const BOT_SKILL_COLORS: Record<BotSkillLevel, string> = {
  novice: '#BBDEFB',
  casual: '#C8E6C9',
  regular: '#FFE0B2',
  expert: '#EF9A9A'
}

export const BOT_SKILL_LABELS: Record<BotSkillLevel, string> = {
  novice: 'Novice',
  casual: 'Casual',
  regular: 'Regular',
  expert: 'Expert'
}
